var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGasTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg_icon",
    viewBox: "0 0 26 14.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#243A53;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.1,12.7a2,2,0,1,1-2-2A2,2,0,0,1,6.1,12.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,12.7a2,2,0,1,1-2-2A2,2,0,0,1,12,12.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.4,12.7a1.9,1.9,0,0,1-2,2,2,2,0,0,1,0-4A1.9,1.9,0,0,1,22.4,12.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.6.6H18.5V8.3H0V9.5H26V4.6ZM20.2,2.1h2.5l1.5,2.5h-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.2,6.9H3.5A3.5,3.5,0,0,1,0,3.5,3.5,3.5,0,0,1,3.5,0h9.7a3.5,3.5,0,0,1,3.6,3.5A3.5,3.5,0,0,1,13.2,6.9Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGasTruck);
export default __webpack_public_path__ + "static/media/icon-gas-truck.07d0efe6ff0cfbcc61d7d6a48f568cc4.svg";
export { ForwardRef as ReactComponent };